import { _isOnScreen } from '../../utils';

_isOnScreen(
  '.header__beacon',
  () => {
    document.querySelector('header').classList.remove('fixed');
    document
      .querySelectorAll('.header__menu-desktop-dropdown')
      .forEach(dropdown => dropdown.classList.remove('real-fixed'));
    document.querySelector('body').classList.remove('with-fixed-header');
  },
  {},
  () => {
    document.querySelector('header').classList.add('fixed');
    document
      .querySelectorAll('.header__menu-desktop-dropdown')
      .forEach(dropdown => dropdown.classList.add('real-fixed'));
    document.querySelector('body').classList.add('with-fixed-header');
  },
);
